<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from "axios";
//import DataTable from 'datatables.net-vue3';
import moment from "moment";
import Swal from "sweetalert2";
import { usePermissions } from '@/composables/usePermissions';

export default {
  page: {
    title: "Contract Information",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      role: localStorage.getItem("role"),
      title: "Contract Information",
      contrtact_info: [],
      contractstatuslist: [],
      contract_number: "",
      customer_fullname: "",
      capcity: "",
      color_hex_code: "",
      price: "",
      product_name: "",
      sku: "",
      imei: "",
      color_name: "",
      orderId: "",
      contract_date: "",
      contract_end_date: "",
      contract_status_id: "",
      subscription_period: "",
      contractpdf: "",

      cloudFrontURL: process.env.VUE_APP_BUCKET,
    };
  },
    setup() {
        const permissions = usePermissions();
        
        return {
            permissions,
        };
    },
  methods: {
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY H:m:s");
      }
    },
    get_contract_details_by_id() {
      axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
      axios
        .get(process.env.VUE_APP_API_BASEURL + "contract/edit/" + this.$route.params.cid)
        .then((response) => {
          if (response) {
            this.loadingRoles = false;
            this.contrtact_info = response.data;
            this.contract_number = this.contrtact_info[0].contract_number;
            this.customer_fullname = this.contrtact_info[0].name_as_per_nric;
            this.capcity = this.contrtact_info[0].capcity_name;
            this.color_hex_code = this.contrtact_info[0].color_hex_code;
            this.price = "RM " + this.contrtact_info[0].price;
            this.product_name = this.contrtact_info[0].product_name;
            this.sku = this.contrtact_info[0].sku;
            this.imei = this.contrtact_info[0].imei;
            this.orderId = this.contrtact_info[0].orderId;
            this.color_name = this.contrtact_info[0].color_name;
            this.contract_date = this.contrtact_info[0].contract_date;
            this.contract_end_date = this.contrtact_info[0].contract_end_date;
            this.contract_status_id = this.contrtact_info[0].contract_status_id;
            this.subscription_period = this.contrtact_info[0].subscription_period;
            this.contractpdf = this.contrtact_info[0].contractpdf;
            console.log(this.contrtact_info);
          } else {
            this.messageBag = ["No record."];
          }
        })
        .catch((error) => {
          this.messageBag = [error.error];
        });
    },

    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    update_customer_contract(e) {
      e.preventDefault();
      Swal.fire({
        title: "Are you sure you want to change the contract status? An email might trigger to the customer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Update",
      }).then((result) => {
        if (result.isConfirmed) {
          this.ButtonSeen = true;

          const posting_ = {
            contract_status_id: this.contract_status_id,
            imei: this.imei,
          };

          axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
          axios
            .post(process.env.VUE_APP_API_BASEURL + "contract/update/" + this.$route.params.cid, posting_)
            .then((response) => {
              if (response) {
                this.ButtonSeen = false;
                alert(response.data.msj);
              } else {
                this.ButtonSeen = false;
                console.log("tak ok");
              }
            });
        }
      });
    },
    update_imei(e) {
      this.ButtonSeen = true;
      e.preventDefault();

      const posting_ = {
        imei: this.imei,
      };

      axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
      axios
        .post(process.env.VUE_APP_API_BASEURL + "contract/update/imei/" + this.$route.params.cid, posting_)
        .then((response) => {
          if (response) {
            this.ButtonSeen = false;
            alert(response.data.msj);
          } else {
            this.ButtonSeen = false;
            console.log("tak ok");
          }
        });
    },
    //raw data----------------------------------------------------------
    get_contract_status() {
      axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
      axios
        .get(process.env.VUE_APP_API_BASEURL + "contractstatus/list")
        .then((response) => {
          if (response) {
            this.loadingRoles = false;
            this.contractstatuslist = response.data;
            console.log("Contract Detail", this.contractstatuslist);
          } else {
            this.messageBag = ["No record."];
          }
        })
        .catch((error) => {
          this.messageBag = [error.error];
        });
    },

    //raw data----------------------------------------------------------
  },

  components: {
    Layout,
    PageHeader,
  },

  mounted() {
    this.get_contract_details_by_id();
    this.get_contract_status();
    //this.get_country();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-6">
        <div class="card">
          <div class="card-header">
            <div class="d-flex">
              <h5><i class="ri-function-fill text-muted align-bottom me-1"></i># {{ contract_number }}</h5>
            </div>
          </div>
          <div class="card-body">
            <div class="live-preview">
              <form @submit="update_customer_contract">
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="branch_name" class="form-label">Contract Number</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model="contract_number" type="text" class="form-control" id="contract_number" readonly />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="branch_code" class="form-label">Contract Date</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model="contract_date" type="date" class="form-control" id="branch_code" readonly />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="channel_partner_id" class="form-label">Contract End Date</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model="contract_end_date" type="date" class="form-control" id="branch_code" readonly />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="email" class="form-label">Contract Status</label>
                  </div>
                  <div class="col-lg-8">
                    <select
                      v-model="contract_status_id"
                      class="form-select mb-3"
                      arial-label="Default select example"
                      placeholder="Please Select"
                      required
                    >
                      <option value="">--- Select ---</option>
                      <option v-for="(item, index) in contractstatuslist" :key="index" :value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="email2" class="form-label">Order Number</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model="orderId" type="text" class="form-control" id="email2" readonly />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="phone_number" class="form-label">Customer Name</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model="customer_fullname" type="text" class="form-control" id="phone_number" readonly />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="subscription_period" class="form-label">Tenure (In Months)</label>
                  </div>
                  <div class="col-lg-8">
                    <input
                      v-model="subscription_period"
                      type="text"
                      class="form-control"
                      id="subscription_period"
                      readonly
                    />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="zip" class="form-label">Contract :</label>&nbsp;&nbsp;&nbsp;&nbsp;
                  </div>
                  <div class="col-lg-8">
                    <a v-bind:href="cloudFrontURL + contractpdf" target="_blank" rel="noreferrer noopener"
                      >Click Here to View Contract</a
                    >
                  </div>
                </div>
                <hr class="my-4 text-muted" />
                <div class="text-end col-lg-12">
                  <a @click="$router.go(-1)" class="btn btn-success">Back</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button v-if="permissions.canUpdate?.value" type="submit" class="btn btn-primary" >Update</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-6">
        <div class="card">
          <div class="card-header">
            <div class="d-flex">
              <h5><i class="ri-function-fill text-muted align-bottom me-1"></i>DEVICE INFO</h5>
            </div>
          </div>
          <div class="card-body">
            <form @submit="update_imei">
              <div>
                <div class="row g-4">
                  <div class="col-lg-4">
                    <label for="branch_name" class="form-label">SKU</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model="sku" type="text" class="form-control" id="branch_name" readonly />
                  </div>

                  <div class="col-lg-4">
                    <label for="color_name" class="form-label">Color Name</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model="color_name" type="text" class="form-control" id="color_name" readonly />
                  </div>

                  <div class="col-lg-4">
                    <label for="branch_name" class="form-label">Color Hex Code</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model="color_hex_code" type="text" class="form-control" id="branch_name" readonly />
                  </div>

                  <div class="col-lg-4">
                    <label for="branch_name" class="form-label">IMEI</label>
                  </div>
                  <div class="col-lg-8">
                    <input
                      v-on:keypress="NumbersOnly"
                      v-model="imei"
                      type="text"
                      class="form-control"
                      id="branch_name"
                      maxlength="20"
                      minlength="9"
                    />
                  </div>

                  <div class="col-lg-4">
                    <label for="branch_name" class="form-label">Price</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model="price" type="text" class="form-control" id="branch_name" readonly />
                  </div>

                  <div class="col-lg-4">
                    <label for="branch_name" class="form-label">Capacity</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model="capcity" type="text" class="form-control" id="branch_name" readonly />
                  </div>
                </div>

                <hr class="my-4 text-muted" />
                <div class="text-end col-lg-12">
                  <a @click="$router.go(-1)" class="btn btn-success">Back</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button v-if="permissions.canUpdate?.value" type="submit" class="btn btn-primary" >Update</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
